// extracted by mini-css-extract-plugin
module.exports = {"lightboxWrapper":"dlc-lightbox-nordics_lightboxWrapper__T0Fq_","lightbox__headline":"dlc-lightbox-nordics_lightbox__headline__xfhZH","orders":"dlc-lightbox-nordics_orders__W2Jxf"};